module.exports = __webpack_public_path__ + "img/zfcg_14.6f4d8750.png";